import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Platform } from '@ionic/angular/standalone';
import { IonButton, IonCol, IonGrid, IonIcon, IonRow } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { logoAndroid, logoApple, refresh } from 'ionicons/icons';
import { SelectStudentEventPayload } from 'src/app/models/event-payloads.model';
import { UnknownItemViewModel } from 'src/app/models/item.model';
import { AnnouncementPublisherComponent } from '../announcement-publisher/announcement-publisher.component';
import { AttachmentsComponent } from '../attachments/attachments.component';
import { HubItemMessageComponent } from '../hub-item-message/hub-item-message.component';
import { ListItemHeaderComponent } from '../list-item-header/list-item-header.component';

@Component({
  selector: 'app-unknown-item',
  templateUrl: './unknown-item.component.html',
  styleUrls: ['./unknown-item.component.scss'],
  imports: [
    ListItemHeaderComponent,
    HubItemMessageComponent,
    AttachmentsComponent,
    AnnouncementPublisherComponent,
    IonGrid,
    IonRow,
    IonCol,
    IonButton,
    IonIcon
  ]
})
export class UnknownItemComponent {
  @Input() item: UnknownItemViewModel;
  @Input() showPublisherLink: boolean;
  @Output() selectItem = new EventEmitter<string>();
  @Output() selectStudent = new EventEmitter<SelectStudentEventPayload>();
  @Output() openAttachment = new EventEmitter<string>();
  @Output() getThumb = new EventEmitter<string>();

  constructor(public platform: Platform) {
    addIcons({ logoApple, logoAndroid, refresh });
  }
}
